import { __assign } from "tslib";
import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { PnmacHeadline, PnmacSubheading } from "pnmac-universal-components";
import RefiPnmac from "./RefiPnmac";
import { textStyle } from '../../v2/theme';
function PayMortgage(_a) {
  var translations = _a.translations,
    payOffReason = _a.payOffReason,
    tealiumReason = _a.tealiumReason;
  var _b = useState(false),
    request = _b[0],
    setRequest = _b[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, !request && /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: styles.sectionHeadline
  }, "Congrats!"), /*#__PURE__*/React.createElement(PnmacSubheading, {
    style: styles.sectionSubheader
  }, translations.CongratsSubheader)), /*#__PURE__*/React.createElement(RefiPnmac, {
    tealiumReason: tealiumReason,
    translations: translations,
    onPressStatement: function () {
      return setRequest(true);
    },
    payOffReason: payOffReason
  }));
}
var styles = StyleSheet.create({
  container: {
    marginTop: 20,
    marginHorizontal: 5,
    alignItems: "center"
  },
  sectionHeadline: {
    fontSize: 34
  },
  sectionSubheader: __assign(__assign({}, textStyle.defaultTextTitle), {
    color: "#707070",
    marginTop: 20
  })
});
export default PayMortgage;